import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dca74692"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "入库", -1))
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "装柜", -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "报关放行", -1))
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "装货港", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "目的港", -1))
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "清关放行", -1))
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "提柜", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "送达", -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "content" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 8 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bolder","font-size":"16px","color":"#333"} }, " 追踪信息 ", -1))
const _hoisted_27 = {
  key: 1,
  class: "empty-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_express_tracking = _resolveComponent("express-tracking")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      [
        _ctx.services.any((it) => it.Value == 'DeparturePortWarehouse'),
        _ctx.services.any((it) => it.Value == 'DeparturePortContainer'),
        _ctx.services.any((it) => it.Value == 'DeparturePortDeclareCustoms'),
        _ctx.services.any((it) => it.Value == 'DeparturePortBooking'),
        _ctx.services.any((it) => it.Value == 'DestinationPortClearCustoms'),
        _ctx.services.any((it) => it.Value == 'DestinationPortContainer') ||
          _ctx.services.any((it) => it.Value == 'DestinationPortTrunk') ||
          _ctx.services.any((it) => it.Value == 'DestinationPortExpress'),
        _ctx.services.any((it) => it.Value == 'DestinationPortContainer') ||
          _ctx.services.any((it) => it.Value == 'DestinationPortTrunk') ||
          _ctx.services.any((it) => it.Value == 'DestinationPortExpress'),
      ].filter((it) => it).length > 1
    )
      ? (_openBlock(), _createBlock(_component_el_steps, {
          key: 0,
          style: {"margin-bottom":"10px","padding-right":"15px","padding-left":"40px"}
        }, {
          default: _withCtx(() => [
            (_ctx.services.any((it) => it.Value == 'DeparturePortWarehouse'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 0,
                  status: 
        _ctx.detail?.DeparturePortWarehouseList?.any((it) => it.InStockTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_1
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.DeparturePortWarehouseList?.filter(
              (it) => it.InStockTime
            ).sort((a, b) => _ctx.moment(a.InStockTime).diff(b.InStockTime)), (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "time-text",
                            key: i,
                            title: _ctx.moment(item.InStockTime).format('YYYY/MM/DD HH:mm')
                          }, _toDisplayString(_ctx.moment(item.InStockTime).format("YYYY/MM/DD HH:mm")), 9, _hoisted_2))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (_ctx.services.any((it) => it.Value == 'DeparturePortContainer'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 1,
                  status: 
        _ctx.detail?.DeparturePortContainerList?.any((it) => it.ArrivalTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_3
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.DeparturePortContainerList?.filter(
              (it) => it.ArrivalTime
            ).sort((a, b) => _ctx.moment(a.ArrivalTime).diff(b.ArrivalTime)), (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "time-text",
                            key: i,
                            title: _ctx.moment(item.ArrivalTime).format('YYYY/MM/DD HH:mm')
                          }, _toDisplayString(_ctx.moment(item.ArrivalTime).format("YYYY/MM/DD HH:mm")), 9, _hoisted_4))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (_ctx.services.any((it) => it.Value == 'DeparturePortDeclareCustoms'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 2,
                  status: 
        _ctx.detail?.DeparturePortDeclareCustomsList?.any((it) => it.ReleaseTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_5
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.DeparturePortDeclareCustomsList?.filter(
              (it) => it.ReleaseTime
            ).sort((a, b) => _ctx.moment(a.ReleaseTime).diff(b.ReleaseTime)), (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "time-text",
                            key: i,
                            title: _ctx.moment(item.ReleaseTime).format('YYYY/MM/DD HH:mm')
                          }, _toDisplayString(_ctx.moment(item.ReleaseTime).format("YYYY/MM/DD HH:mm")), 9, _hoisted_6))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (_ctx.services.any((it) => it.Value == 'DeparturePortBooking'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 3,
                  status: 
        _ctx.detail?.DeparturePortBookingList?.any((it) => it.ActualDepartureDate)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_7
                  ]),
                  description: _withCtx(() => [
                    (
            _ctx.detail?.DeparturePortBookingList?.firstOrDefault()
              ?.EstimatedDepartureDate
          )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "time-text",
                          title: 
            'ETD：' +
            _ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].EstimatedDepartureDate
            ).format('YYYY/MM/DD HH:mm')
          
                        }, " ETD：" + _toDisplayString(_ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].EstimatedDepartureDate
            ).format("YYYY/MM/DD HH:mm")), 9, _hoisted_8))
                      : _createCommentVNode("", true),
                    (
            _ctx.detail?.DeparturePortBookingList?.firstOrDefault()
              ?.ActualDepartureDate
          )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "time-text",
                          title: 
            'ATD：' +
            _ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].ActualDepartureDate
            ).format('YYYY/MM/DD HH:mm')
          
                        }, " ATD：" + _toDisplayString(_ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].ActualDepartureDate
            ).format("YYYY/MM/DD HH:mm")), 9, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (_ctx.services.any((it) => it.Value == 'DeparturePortBooking'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 4,
                  status: 
        _ctx.detail?.DeparturePortBookingList?.any((it) => it.ActualArrivalDate)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_10
                  ]),
                  description: _withCtx(() => [
                    (
            _ctx.detail?.DeparturePortBookingList?.firstOrDefault()
              ?.EstimatedArrivalDate
          )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "time-text",
                          title: 
            'ETA：' +
            _ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].EstimatedArrivalDate
            ).format('YYYY/MM/DD HH:mm')
          
                        }, " ETA：" + _toDisplayString(_ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].EstimatedArrivalDate
            ).format("YYYY/MM/DD HH:mm")), 9, _hoisted_11))
                      : _createCommentVNode("", true),
                    (
            _ctx.detail?.DeparturePortBookingList?.firstOrDefault()
              ?.ActualArrivalDate
          )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "time-text",
                          title: 
            'ATA：' +
            _ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].ActualArrivalDate
            ).format('YYYY/MM/DD HH:mm')
          
                        }, " ATA：" + _toDisplayString(_ctx.moment(
              _ctx.detail?.DeparturePortBookingList[0].ActualArrivalDate
            ).format("YYYY/MM/DD HH:mm")), 9, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (_ctx.services.any((it) => it.Value == 'DestinationPortClearCustoms'))
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 5,
                  status: 
        _ctx.detail?.DestinationPortClearCustomsList?.any((it) => it.ReleaseTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_13
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.DestinationPortClearCustomsList?.filter(
              (it) => it.ReleaseTime
            ).sort((a, b) => _ctx.moment(a.ReleaseTime).diff(b.ReleaseTime)), (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "time-text",
                            key: i,
                            title: _ctx.moment(item.ReleaseTime).format('YYYY/MM/DD HH:mm')
                          }, _toDisplayString(_ctx.moment(item.ReleaseTime).format("YYYY/MM/DD HH:mm")), 9, _hoisted_14))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (
        _ctx.services.any((it) => it.Value == 'DestinationPortContainer') ||
        ((_ctx.services.any((it) => it.Value == 'DestinationPortTrunk') ||
          _ctx.services.any((it) => it.Value == 'DestinationPortExpress')) &&
          _ctx.detail?.ShowCarryContainerTime)
      )
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 6,
                  status: 
        _ctx.detail?.DestinationPortContainerList?.any(
          (it) => it.CarryContainerTime
        ) ||
        _ctx.detail?.DestinationPortTrunkList?.any((it) => it.CarryContainerTime) ||
        _ctx.detail?.DestinationPortExpressList?.any((it) => it.CarryContainerTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_15
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_ctx.detail?.RelationCarryContainerTime)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "time-text",
                              title: `${_ctx.moment(_ctx.detail.RelationCarryContainerTime).format(
              'YYYY/MM/DD HH:mm'
            )}`
                            }, _toDisplayString(_ctx.moment(_ctx.detail.RelationCarryContainerTime).format(
                "YYYY/MM/DD HH:mm"
              )), 9, _hoisted_16))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((
                _ctx.detail?.DestinationPortContainerList?.filter(
                  (it) => it.CarryContainerTime
                ).map((it) => {
                  return {
                    Time: it.CarryContainerTime,
                    Code: it.Code,
                    ContainerNo: it.ContainerNo,
                  };
                }) ?? []
              ).sort((a, b) => _ctx.moment(a.Time).diff(b.Time)), (item, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "time-text",
                                  key: i,
                                  title: `${_ctx.moment(item.Time).format('YYYY/MM/DD HH:mm')}（${
                item.ContainerNo ?? item.Code
              }）`
                                }, _toDisplayString(_ctx.moment(item.Time).format("YYYY/MM/DD HH:mm")) + "（" + _toDisplayString([item.ContainerNo, item.Code].filter((it) => it).join("/")) + "） ", 9, _hoisted_18))
                              }), 128)),
                              (_ctx.detail?.ShowCarryContainerTime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((
                  _ctx.detail?.DestinationPortExpressList?.filter(
                    (it) => it.CarryContainerTime
                  ).map((it) => {
                    return {
                      Time: it.CarryContainerTime,
                      Type: '快递',
                    };
                  }) ?? []
                )
                  .concat(
                    _ctx.detail?.DestinationPortTrunkList?.filter(
                      (it) => it.CarryContainerTime
                    ).map((it) => {
                      return {
                        Time: it.CarryContainerTime,
                        Type: '干线物流',
                      };
                    }) ?? []
                  )
                  .sort((a, b) => _ctx.moment(a.Time).diff(b.Time)), (item, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "time-text",
                                        key: i,
                                        title: `${_ctx.moment(item.Time).format('YYYY/MM/DD HH:mm')}（${
                  item.Type
                }）`
                                      }, _toDisplayString(_ctx.moment(item.Time).format("YYYY/MM/DD HH:mm")) + "（" + _toDisplayString(item.Type) + "） ", 9, _hoisted_20))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true),
            (
        _ctx.services.any((it) => it.Value == 'DestinationPortContainer') ||
        _ctx.services.any((it) => it.Value == 'DestinationPortTrunk') ||
        _ctx.services.any((it) => it.Value == 'DestinationPortExpress')
      )
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 7,
                  status: 
        _ctx.detail?.DestinationPortContainerList?.any((it) => it.ArrivalTime) ||
        _ctx.detail?.DestinationPortTrunkList?.any((it) => it.AllDeliveryTime) ||
        _ctx.detail?.DestinationPortExpressList?.any((it) => it.AllDeliveryTime)
          ? 'finish'
          : 'wait'
      
                }, {
                  icon: _withCtx(() => [
                    _hoisted_21
                  ]),
                  description: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { height: "70px" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((
              _ctx.detail?.DestinationPortContainerList?.filter(
                (it) => it.ArrivalTime
              ).map((it) => {
                return {
                  Time: it.ArrivalTime,
                  PlanTime: it.PlanTime,
                  Type: '集装箱',
                };
              }) ?? []
            )
              .concat(
                _ctx.detail?.DestinationPortExpressList?.filter(
                  (it) => it.AllDeliveryTime
                ).map((it) => {
                  return {
                    Time: it.AllDeliveryTime,
                    PlanTime: it.PlanDeliveryTime,
                    Type: '快递',
                  };
                }) ?? []
              )
              .concat(
                _ctx.detail?.DestinationPortTrunkList?.filter(
                  (it) => it.AllDeliveryTime
                ).map((it) => {
                  return {
                    Time: it.AllDeliveryTime,
                    PlanTime: it.PlanDeliveryTime,
                    Type: '干线物流',
                  };
                }) ?? []
              )
              .sort((a, b) => _ctx.moment(a.Time).diff(b.Time)), (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "time-text",
                            key: i,
                            title: `ETA：${_ctx.moment(item.PlanTime).format('YYYY/MM/DD HH:mm')} ATA：${_ctx.moment(item.Time).format('YYYY/MM/DD HH:mm')}（${
              item.Type
            }）`
                          }, " ETA：" + _toDisplayString(_ctx.moment(item.Time).format("YYYY/MM/DD HH:mm")) + " ATA：" + _toDisplayString(_ctx.moment(item.Time).format('YYYY/MM/DD HH:mm')) + "（" + _toDisplayString(item.Type) + "） ", 9, _hoisted_22))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["status"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_timeline, { class: "services" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (item, i) => {
          return (_openBlock(), _createBlock(_component_el_timeline_item, {
            key: i,
            "hide-timestamp": true,
            placement: "top",
            class: _normalizeClass(`label ${item.Class} ${item.Value == _ctx.service ? 'active' : ''}`),
            onClick: ($event: any) => (_ctx.handleServiceClick(item.Value ?? ''))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(item.Label), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.tabs.length > 0)
        ? (_openBlock(), _createBlock(_component_el_tabs, {
            key: 0,
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tab) = $event)),
            type: "card",
            "tab-position": "top",
            onTabClick: _ctx.handleTabClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tabItem, tabIndex) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: tabIndex,
                  label: tabItem.Code,
                  name: tabItem.Id
                }, {
                  default: _withCtx(() => [
                    (_ctx.service == 'DeparturePortBooking')
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 0,
                          modelValue: _ctx.listDeparturePortBooking,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listDeparturePortBooking) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortContainer' ||
            _ctx.service == 'DestinationPortContainer'
          )
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 1,
                          modelValue: _ctx.listContainer,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listContainer) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortExpress' ||
            _ctx.service == 'DestinationPortExpress'
          )
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 2,
                          modelValue: _ctx.listExpress,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listExpress) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortTrunk' || _ctx.service == 'DestinationPortTrunk'
          )
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 3,
                          modelValue: _ctx.listTrunk,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listTrunk) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortDeclareCustoms' ||
            _ctx.service == 'DestinationPortClearCustoms'
          )
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 4,
                          modelValue: _ctx.listCustoms,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listCustoms) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortWarehouse' ||
            _ctx.service == 'DestinationPortWarehouse'
          )
                      ? (_openBlock(), _createBlock(_component_miezz_page_list, {
                          key: 5,
                          modelValue: _ctx.listWharf,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listWharf) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnDetail,
                      onHandleClick: _ctx.handleClick
                    }, null, 8, ["model", "onHandleClick"]),
                    (_ctx.service == 'DeparturePortBooking' && _ctx.api?.ProcessUrl)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 6,
                          src: _ctx.api.ProcessUrl,
                          style: {"width":"100%","height":"700px"}
                        }, null, 8, _hoisted_24))
                      : _createCommentVNode("", true),
                    (
            (_ctx.service == 'DeparturePortDeclareCustoms' ||
              _ctx.service == 'DestinationPortClearCustoms') &&
            _ctx.api &&
            _ctx.api.CustomsList?.any((it) => it.Id == _ctx.tab)
          )
                      ? (_openBlock(), _createBlock(_component_el_timeline, { key: 7 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.api.CustomsList.firstOrDefault(
              (it) => it.Id == _ctx.tab
            )?.ProcessList, (item, i) => {
                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                key: i,
                                timestamp: item.Date,
                                placement: "top",
                                type: "primary",
                                size: "normal"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle(item.Code.indexOf('查验')>-1? 'color:red':'')
                                  }, _toDisplayString(item.Code) + " - " + _toDisplayString(item.Content), 5)
                                ]),
                                _: 2
                              }, 1032, ["timestamp"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
            _ctx.service == 'DeparturePortExpress' ||
            _ctx.service == 'DestinationPortExpress'
          )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_express_tracking, {
                            modelValue: tabItem.Id,
                            "onUpdate:modelValue": ($event: any) => ((tabItem.Id) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_27, "暂无数据"))
    ])
  ], 64))
}